import { useState } from "react";
import axios, { clearAuthContext } from "../lib/api";
import { API } from "../App";
import { Shield, X } from "lucide-react";
import { toast } from "sonner";

export default function ImpersonationBanner() {
  const [exiting, setExiting] = useState(false);
  const targetRaw = localStorage.getItem("impersonation_target");
  const adminToken = localStorage.getItem("impersonation_admin_token");

  if (!targetRaw || !adminToken) return null;

  let target;
  try { target = JSON.parse(targetRaw); } catch { return null; }

  const handleExit = async () => {
    setExiting(true);
    try {
      const impToken = localStorage.getItem("impersonation_token");
      await axios.post(`${API}/admin/impersonate/exit`, {}, {
        headers: { Authorization: `Bearer ${impToken}` }
      });
    } catch {
      // Best-effort audit close
    }

    // Restore admin session tokens
    localStorage.setItem("auth_token", adminToken);
    localStorage.setItem("token", adminToken);

    // Clear the impersonation session cookie so the backend doesn't use stale data
    document.cookie = "session_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";

    // Clear all org data for the impersonated user
    clearAuthContext();

    // Restore admin's org context from saved backup
    const adminContextRaw = localStorage.getItem("impersonation_admin_context");
    if (adminContextRaw) {
      try {
        const adminCtx = JSON.parse(adminContextRaw);
        if (adminCtx.user_id) {
          localStorage.setItem("active_user_id", adminCtx.user_id);
          if (adminCtx.org_id) {
            localStorage.setItem(`active_org_id:${adminCtx.user_id}`, adminCtx.org_id);
          }
        }
        // Restore admin's session cookie if it existed
        if (adminCtx.session_cookie) {
          document.cookie = `session_token=${adminCtx.session_cookie}; path=/; secure; samesite=lax`;
        }
      } catch { /* ignore parse errors */ }
    }

    // Clean up all impersonation keys
    localStorage.removeItem("impersonation_token");
    localStorage.removeItem("impersonation_admin_token");
    localStorage.removeItem("impersonation_log_id");
    localStorage.removeItem("impersonation_target");
    localStorage.removeItem("impersonation_admin_context");

    toast.success("Sesión de soporte finalizada");
    // Full page reload to re-initialize all state with admin context
    window.location.href = "/admin";
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950" data-testid="impersonation-banner">
      <div className="flex items-center justify-center gap-3 px-4 py-2 text-sm font-medium">
        <Shield className="w-4 h-4" />
        <span>Modo soporte — Viendo como <strong>{target.email}</strong></span>
        <button
          onClick={handleExit}
          disabled={exiting}
          className="ml-2 px-3 py-0.5 bg-amber-700 text-white rounded-full text-xs hover:bg-amber-800 transition-colors inline-flex items-center gap-1"
          data-testid="exit-impersonation-btn"
        >
          {exiting ? "Saliendo..." : <><X className="w-3 h-3" /> Salir</>}
        </button>
      </div>
    </div>
  );
}
